import { MenuListModel } from '../models/menu.model'

export const LISTROUTES: MenuListModel[] = [
  {
    type: 'title',
    label: 'Home',
    route: 'home',
    permission: 'view-sempre',
  },
  {
    type: 'subTitle',
    label: 'Cadastro',
    children: [
      {
        label: 'Paciente',
        route: 'paciente',
        permission: 'view-paciente',
      },
      {
        label: 'Administrador',
        route: 'administrador',
        permission: 'view-administrador',
      },
      {
        label: 'Tutor Local',
        route: 'tutor-local',
         permission: 'view-tutor-local',
      },
      {

        label: 'Unidade de Saúde',
        route: 'unidade-saude',
        permission: 'view-unidade-de-saúde',
      },
      {
        label: 'Município',
        route: 'municipio',
        permission: 'view-municipio'
      },
      {
        label: 'Hiperdia',
        route: 'central-hiperdia',
          permission: 'view-hiperdia',
      },
      {
        label: 'Hábito',
        route: 'habito',
       permission: 'view-hábito',
      },
      {
        label: 'Doenças Prévias',
        route: 'doencas-previas',
       permission: 'view-doenças-prévias',
      },
      {
        label: 'Convênio',
        route: 'convenio',
       permission: 'view-convenio',
      },
      {
        label: 'Regra de Alerta',
        route: 'regra-alerta',
       permission: 'view-regra-alerta',
      },
      {
        label: 'Mensageria',
        route: 'mensageria',
       permission: 'view-mensagemtemplate',
      },
      {
        label: 'Classificação',
        route: 'classificacao',
       permission: 'view-classificacao',
      },

      {
        label: 'Exame',
        route: 'exame',
       permission: 'view-exame',
      },
      {
        label: 'Conteúdo - Sugestão',
        route: 'conteudo-sugestao',
       permission: 'view-conteudo',
      },
      {
        label: 'Contexto de Medição',
        route: 'contexto-medicao',
       permission: 'view-contexto',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Cadastrar Tipos',
    children: [
      {
        label: 'Perfil',
        route: 'tipo-perfil',
       permission: 'view-perfil',
      },
      {
        label: 'Exame',
        route: 'tipo-exame',
        permission: 'view-tipo-exame',
      },
      {
        label: 'Uso - Mensagem',
        route: 'tipo-uso',
        permission: 'view-tipos-de-uso',
      },
      {
        label: 'Conteúdo - Sugestão',
        route: 'tipo-conteudo',
        permission: 'view-tipo-conteudo',
      },
      {
        label: 'Unidade de Medida',
        route: 'tipo-unidade-medida',
       permission: 'view-tipo-unidade-de-medida',
      },
    ],
  },
  {
    type: 'subTitle',
    label: 'Relatórios',
    children: [
      {
      label: "Medições",
      route: 'relatorio-medicao',
      permission: 'view-relátorio-medição',
      },
      ],

  },
  {
    type: 'title',
    label: 'Pendência - Pacientes',
    route: 'alertas-pendentes',
    permission: 'view-dashboard-gestao'
  },
]
